export default __webpack_public_path__ + "static/media/exploded-view_labels.8e9a1ff9.png";